import { Observable, Observer } from 'rxjs';

const BYTE_STEPS = 4;
const BYTE_SIZE = 16;

export class CryptoUtils {
  public static Sha256(text: string): Observable<string> {
    return new Observable((observer: Observer<string>) => {
      try {
        const buffer = new TextEncoder().encode(text);
        crypto.subtle.digest('SHA-256', buffer).then(
          (hash: ArrayBuffer) => {
            observer.next(CryptoUtils.hex(hash));
            observer.complete();
          },
          (error: unknown) => {
            observer.error(error);
            observer.complete();
          }
        );
      } catch (error) {
        observer.error(error);
        observer.complete();
      }
    });
  }

  private static hex(buffer: ArrayBuffer) {
    const hexCodes = new Array(0);
    const view = new DataView(buffer);
    for (let i = 0; i < view.byteLength; i += BYTE_STEPS) {
      // Using getUint32 reduces the number of iterations needed (we process 4 bytes each time)
      const value = view.getUint32(i);
      // toString(16) will give the hex representation of the number without padding
      const stringValue = value.toString(BYTE_SIZE);
      // We use concatenation and slice for padding
      const padding = '00000000';
      const paddedValue = (padding + stringValue).slice(-padding.length);
      hexCodes.push(paddedValue);
    }
    // Join all the hex strings into one
    return hexCodes.join('');
  }
}
